/** Opens «Aktivität teilen» modal on Entdecken (canonical share / WhatsApp invite target). */
export const ACTIVITY_SHARE_PARAM = "aktivitaetTeilen";
export const ACTIVITY_SHARE_VALUE = "1";

/** Opens «Aktivität teilen» modal on Home after login (`login?redirect=…`). */
export const HOME_QUELLE_OPEN_PARAM = "nachQuelle";
export const HOME_QUELLE_OPEN_VALUE = "1";

export function getActivitySharePath() {
  return `/entdecken?${ACTIVITY_SHARE_PARAM}=${ACTIVITY_SHARE_VALUE}`;
}

export function getHomeQuelleOpenPath() {
  return `/?${HOME_QUELLE_OPEN_PARAM}=${HOME_QUELLE_OPEN_VALUE}`;
}

export function getActivityShareAbsoluteUrl() {
  if (typeof window === "undefined") return "";
  return `${window.location.origin}${getActivitySharePath()}`;
}

/** Full URL to open Entdecken with a specific column + card (stable path for WhatsApp / SMS). */
export function buildActivityCardShareUrl({ origin, columnId, eventId }) {
  const base =
    (typeof origin === "string" && origin) ||
    (typeof window !== "undefined" ? window.location.origin : "");
  const q = new URLSearchParams();
  q.set("column", String(columnId));
  q.set("event", String(eventId));
  return `${base}/entdecken?${q.toString()}`;
}
